angular.
module("dx.webapp.printing").
directive("dxPrintAnswerItem", function printAnswerItemDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			showOnlyQuestions: "<",
			exam: "=",
			question: "=",
			student: "=",
			answer: "=",
			examParts: "=",
			accessibilityFlags: "<?",
			doubleLineHeight: "=?",
			showStudentNames: "=?",
			showEmail: "=?",
			showStudentCodes: "=?",
		},
		templateUrl: "tmpl/printing/print-answer-item-directive.html",
		controller: "dxPrintAnswerItemController",
		controllerAs: "vm",
		bindToController: true,
	};
});
